// Copyright (c) 2022 by Move Closer

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const brandTeaserCarouselConfig = {
  autoplay: false,
  centralize: false,
  delay: 3000,
  hasPagination: true,
  hasButtons: true,
  initialSlide: 0,
  inLoop: false,
  pauseOnHover: true,
  responsive: {
    mobile: {
      perPage: 2.5,
      hasButtons: false,
      hasPagination: false
    },
    desktop: { perPage: 6 }
  }
}
